import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> SAR DL Audit </li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>SAR DL Audit</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  A SAR DL (Security Audit & Review – Data Loss) Audit is a
                  comprehensive assessment designed to evaluate your
                  organization’s ability to detect, prevent, and respond to data
                  loss incidents. With growing risks of insider threats,
                  accidental leaks, and external breaches, ensuring your data
                  remains secure is not just a compliance requirement—it’s a
                  business necessity. At [Your Company Name], we provide
                  end-to-end SAR DL Audits that help you identify gaps,
                  strengthen controls, and safeguard sensitive data across your
                  digital environment.
                </p>
              </div>

              {/* Why It Matters */}
              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Prevent Data Breaches",
                    desc: "Identify and mitigate risks before they lead to costly leaks.",
                  },
                  {
                    icon: "fa-database",
                    title: "Regulatory Compliance",
                    desc: "Meet requirements of GDPR, HIPAA, PCI DSS, ISO 27001, and more.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Protect Business Reputation",
                    desc: "Avoid financial, legal, and reputational damage caused by data exposure.",
                  },
                  {
                    icon: "fa-table",
                    title: "Strengthen Security Posture",
                    desc: "Gain visibility into vulnerabilities across systems, users, and processes.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Boost Client Confidence",
                    desc: "Demonstrate your commitment to data privacy and protection.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>Our SAR DL Audit follows a structured and proven framework:</p>
                      <ul>
                        <li><b>Scoping & Planning :-</b> Define audit scope (applications, databases, endpoints, networks).</li>
                        <li><b>Risk Assessment :-</b> Identify data leakage points, shadow IT, and weak controls.</li>
                        <li><b>Policy & Control Review :-</b> Evaluate existing security policies, DLP solutions, and user access controls.</li>
                        <li><b>Data Flow Analysis :-</b> Map how sensitive data is stored, accessed, and transmitted.</li>
                        <li><b>Simulation & Testing :-</b> Perform controlled data leak simulations to assess real-world resilience.</li>
                        <li><b>Gap Identification :-</b> Highlight weak points and compliance risks.</li>
                        <li><b>Remediation Roadmap :-</b> Provide actionable steps to strengthen data protection.</li>
                        <li><b>Final Audit Report :-</b> Deliver a comprehensive audit-ready report with findings and recommendations.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Prevent accidental or intentional data loss.</li>
                        <li>Improve resilience against insider threats.</li>
                        <li>Streamline compliance with global regulations.</li>
                        <li>Reduce financial and reputational risks.</li>
                        <li>Gain audit-ready documentation for regulators and stakeholders.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li>SAR DL Gap Assessment Report</li>
                        <li>Data Flow & Leakage Risk Map</li>
                        <li>Customized Risk & Control Matrix</li>
                        <li>Compliance Mapping Report (GDPR, HIPAA, PCI DSS, ISO)</li>
                        <li>Remediation Roadmap with Prioritized Actions</li>
                        <li>Final SAR DL Audit Report & Executive Summary</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Our Approach */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <ul>
                    <li><b>Expert Auditors :-</b> Certified specialists with expertise in DLP, SOC, ISO, and regulatory frameworks.</li>
                    <li><b>Holistic Coverage :-</b> across endpoints, applications, cloud, and networks.</li>
                    <li><b>Compliance Alignment :-</b> Mapping with GDPR, HIPAA, PCI DSS, ISO 27001, NIST.</li>
                    <li><b>Tailored Solutions :-</b> Industry-specific audit strategies for BFSI, healthcare, SaaS, and IT providers.</li>
                    <li><b>Proven Track Record :-</b> Trusted by enterprises for effective audits and remediation support.</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
